import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0aba01e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import { AVATAR_DEFAULT } from '@/data/room'
import { onImageError } from '@/helpers/favicon'
import { computed, PropType } from 'vue'
type DotColorType = 'green' | 'red' | 'yellow'

export default /*#__PURE__*/_defineComponent({
  __name: 'Avatar',
  props: {
  avatar: {
    type: String,
    default: AVATAR_DEFAULT,
  },
  size: {
    type: Number,
    default: 48,
  },
  hasDot: {
    type: Boolean,
    default: false,
  },
  dotColor: {
    type: String as PropType<DotColorType>,
    default: 'green',
  },
},
  setup(__props) {

_useCssVars(_ctx => ({
  "7c9be66e": (width.value),
  "05dc2502": (height.value)
}))

const props = __props

const width = computed(() => `${props.size}px`)
const height = computed(() => `${props.size}px`)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["avatar-wrapper", [__props.hasDot && 'has-dot']])
  }, [
    _createElementVNode("img", {
      src: __props.avatar || '',
      alt: "",
      onErrorOnce: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onImageError) && _unref(onImageError)(...args)))
    }, null, 40, _hoisted_1)
  ], 2))
}
}

})